import React from 'react';

const Youtube = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill="#FFF">
        <g>
          <g>
            <path
              d="M10.348 14.213V9.419l4.322 2.405-4.322 2.389zm9.492-5.624s-.157-1.176-.636-1.694c-.608-.68-1.29-.683-1.603-.722C15.362 6 12.004 6 12.004 6h-.008S8.638 6 6.4 6.173c-.313.04-.995.042-1.604.722-.479.518-.635 1.694-.635 1.694S4 9.969 4 11.349v1.295c0 1.381.16 2.762.16 2.762s.156 1.175.635 1.693c.61.68 1.409.658 1.765.73C7.84 17.958 12 18 12 18s3.362-.005 5.601-.178c.313-.04.995-.043 1.603-.723.48-.518.636-1.693.636-1.693s.16-1.38.16-2.762V11.35c0-1.38-.16-2.761-.16-2.761z"
              transform="translate(-108 -694) translate(60 694) translate(48)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Youtube;
